// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"f6d35550","453":"de8e7da6"}[chunkId] + ".chunk.js";
};